import getContext from '@/utilities/get-context';
import { mapSimpleGetters } from '@/utilities/vuex-helpers';

export default {
  state: {
    seller: {
      ...getContext().__MA__.seller_additional_data,
      ...getContext().__MA__.seller,
    },
  },

  mutations: {
    updateSeller(state, newData) {
      state.seller = { ...state.seller, ...newData };
    },
  },

  actions: {
    updateSeller({ commit }, newData) {
      commit('updateSeller', newData);
    },
  },

  getters: {
    ...mapSimpleGetters([
      'seller',
    ]),
  },
};
